import { get } from 'lodash'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import dialog from '@/components/services/otp-verification/dialog'

function renderField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.data.phone,
        label: this.getTranslate(`${Services.users}.labels.data.phone`),
        error: get(this.errors, 'data.phone'),
        disabled: this.disabled,
        trim: true,
        dense: true,
        clearable: true,
        required: true,
        details: false,
        tabindex: 4
      },
      on: {
        input: event => {
          this.proxy.data.phone = event
        }
      }
    }
  )
}
function renderSwitch(h) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.data.meta.isVerifiedByPhone,
        tooltip: this.getTranslate(`${Services.users}.tooltips.data.meta.isVerifiedByPhone`),
        fluid: true,
        outline: true
      },
      on: {
        input: event => {
          this.proxy.data.meta.isVerifiedByPhone = event
        }
      }
    }
  )
}
function renderConfirmResult(h) {
  return h(
    squircle,
    {
      props: {
        tooltip: this.getTranslate(`${Services.users}.tooltips.isVerifiedByPhone`),
        icon: icons.done,
        color: Colors.success,
        size: sizes.medium
      }
    }
  )
}

function renderConfirmButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.confirm'),
        mode: buttonModes.flat,
        color: Colors.success
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      }
    }
  )
}
function renderConfirmContent(h) {
  if (this.isVerifiedByPhone) {
    return renderConfirmResult.call(this, h)
  }

  if (!this.isOtpVerificationAvailable) {
    return null
  }

  return renderConfirmButton.call(this, h)
}
function renderActions(h) {
  switch (true) {
    case this.canUpdateUsersAsAdmin: return renderSwitch.call(this, h)
    case this.canUpdateUsersAsUser: return renderConfirmContent.call(this, h)
    default: return null
  }
}

function renderDialog(h) {
  if (this.canUpdateUsersAsUser) {
    return h(
      dialog,
      {
        props: {
          value: this.showDialog
        },
        on: {
          input: event => {
            this.showDialog = event
          },
          confirmed: () => {
            this.onConfirmed()
          }
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.users}-form__phone`]: true,
        [`${Services.users}-form__phone--verify`]: this.canUpdateUsersAsAdmin || this.isVerifiedByPhone
      }
    },
    [
      renderField.call(this, h),
      renderActions.call(this, h),
      renderDialog.call(this, h)
    ]
  )
}
